import Button from "@common/components/Button";
import Grid from '@mui/material/Grid2';
import Dialog from "@common/components/Dialog";
import DialogActions from "@common/components/Dialog/DialogActions";
import Typography from "@common/components/Typography";
import { DialogContent, DialogProps } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface ConfirmDialogProps {
  onConfirm: () => void;
  HomeAccountOnlyText?: boolean;
}
const ConfirmDialog = (
  props: ConfirmDialogProps & Pick<DialogProps, "open" | "onClose">
) => {
  const {
    open = false,
    onClose = () => {},
    onConfirm,
    HomeAccountOnlyText = false,
  } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (open === false && loading === true) setLoading(false);
  }, [open]);

  const showDialogText = () => {
    if (HomeAccountOnlyText) {
      return (
        <DialogContent>
          <Typography gutterBottom>
            {t(
              "By proceeding with this change, all users currently in this role will be unlinked from all accounts, except their designated home account."
            )}
          </Typography>
          <Typography gutterBottom>
            {t(
              "This action will remove their access to additional accounts and could disrupt ongoing activities."
            )}
          </Typography>
          <Typography>{t("Are you sure you want to proceed?")}</Typography>
        </DialogContent>
      );
    } else {
      return (
        <DialogContent>
          <Typography gutterBottom>
            {t(
              "By proceeding with this change, all users currently in this role will be unlinked from everything except accounts within their tenant."
            )}
          </Typography>
          <Typography gutterBottom>
            {t(
              "This will restrict their access to any accounts outside of their tenant and could affect their ability to perform tasks across multiple accounts."
            )}
          </Typography>
          <Typography>{t("Are you sure you want to proceed?")}</Typography>
        </DialogContent>
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      {showDialogText()}
      <DialogActions>
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{
            justifyContent: "end",
            "& > *": { mx: 1 }
          }}>
          <Button
            variant="outlined"
            color="greyed"
            onClick={() => onClose({}, "backdropClick")}
          >
            {t("Cancel")}
          </Button>
          <Button
            color="white"
            loading={loading}
            onClick={() => {
              setLoading(true);
              onConfirm();
            }}
          >
            {t("Confirm")}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
